import { render } from "./SimCard.vue?vue&type=template&id=4fde0a62"
import script from "./SimCard.vue?vue&type=script&lang=js"
export * from "./SimCard.vue?vue&type=script&lang=js"
script.render = render

export default script